<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div v-if="canManageEmployees()" class="container py-4">
            <ButtonTag url="employees/kpi/add" :is-tw-main-btn="true" :is-w100="false" class="float-right">
                <div class="pt-1">{{ $t('add') }}</div>
            </ButtonTag>
        </div>

        <div v-if="getKpi" class="mt-5">
            <div class="col-12">
                <div class="border border-gray-300 rounded">
                    <div class="row text-center">
                        <div class="col-12 col-sm-6 col-xl-3">
                            <div class="pt-3">{{ $t('atWork.today') }},</div>
                            <div class="font-weight-bold">{{ getTodayDate() }}</div>
                        </div>
                        <div class="col-12 col-sm-6 col-xl-3">
                            <div class="pt-3">{{ $t('kpi.plan') }}</div>
                            <div class="font-weight-bold">{{ showCurrencyById(getCurrencyByShortName(baseCurrencyShortName).id, getKpi.estimateSaleAmount) }}</div>
                        </div>
                        <div class="col-12 col-sm-6 col-xl-3">
                            <div class="pt-3">{{ $t('kpi.done') }}</div>
                            <div class="font-weight-bold">{{ showCurrencyById(getCurrencyByShortName(baseCurrencyShortName).id, getKpi.realSaleAmount) }}</div>
<!--                            <span class="percent">-->
<!--                                {{ calcDiffPercent(getKpi) }} %-->
<!--                                <font-awesome-icon-->
<!--                                    v-if="parseInt(getKpi.estimateSaleAmount) < parseInt(getKpi.realSaleAmount)"-->
<!--                                    class="icon-link-green"-->
<!--                                    :icon="['fa', 'arrow-up']"-->
<!--                                />-->
<!--                                 <font-awesome-icon-->
<!--                                     v-if="parseInt(getKpi.estimateSaleAmount) > parseInt(getKpi.realSaleAmount)"-->
<!--                                     class="icon-link-red"-->
<!--                                     :icon="['fa', 'arrow-down']"-->
<!--                                 />-->
<!--                            </span>-->
                        </div>
                        <div class="col-12 col-sm-6 col-xl-3">
                            <div class="pt-3">
                                <router-link :to="$i18nHelper.getUrl('employees/kpi/employees')">
                                    {{ $t('kpi.indicatorOfEmployees') }}
                                </router-link>
                            </div>
                            <div class="font-weight-bold">{{ getKpi.avgPercent }} %</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <SearchCollapse :is-bg-white="true" class="container my-4">
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-12 md:col-span-9 btn-group btn-group-toggle flex justify-content-around" data-toggle="buttons">
                    <label class="btn h-11 btn-primary button-stat active font-bold flex align-items-center justify-content-center">
                        <input type="radio" v-model="search.isOnlyActive" @click="searchKpi(true)" name="options" checked>{{ $t('kpi.onlyActives') }}
                    </label>
                    <label class="btn h-11 btn-primary button-stat">
                        <input type="radio" v-model="search.isOnlyActive" @click="searchKpi(false)" name="options">{{ $t('payed') }}
                    </label>
                </div>
                <div class="col-span-12 md:col-span-3">
                    <b-form-select
                        v-model="search.type"
                        class="h-11 border-gray-300 focus:ring-0"
                        @change="searchKpi"
                    >
                        <b-form-select-option value="all">{{ $t('filter.all') }}</b-form-select-option>
                        <b-form-select-option value="0">{{ $t('kpi.period.daily') }}</b-form-select-option>
                        <b-form-select-option value="1">{{ $t('kpi.period.weekly') }}</b-form-select-option>
                        <b-form-select-option value="2">{{ $t('kpi.period.monthly') }}</b-form-select-option>
                    </b-form-select>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-3 mt-4">
                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('filter.thisTime') }}
                    </div>
                    <InputBox
                        class="px-0"
                        :model-form="search"
                        model-name="startAt"
                        :no-margin-top="true"
                        type="date"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('filter.toTime') }}
                    </div>
                    <InputBox
                        class="px-0"
                        :model-form="search"
                        model-name="endAt"
                        :no-margin-top="true"
                        type="date"
                    />
                </div>

                <div class="col-span-12 md:col-span-4">
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 w-50 focus:outline-none">
                        <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchKpi">
                    </button>
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 w-50 focus:outline-none">
                        <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetEmployeeSearchInfo">
                    </button>
                </div>
            </div>

        </SearchCollapse>

        <table class="w-full d-none d-md-table">
            <thead>
                <tr class="h-11 bg-lightGray">
                    <th class="px-2">#</th>
                    <th class="px-2">{{ $t('kpi.type') }}</th>
                    <th class="px-2">{{ $t('kpi.date.startDate') }}</th>
                    <th class="px-2">{{ $t('kpi.date.endDate') }}</th>
                    <th class="px-2">{{ $t('kpi.sum') }}</th>
                    <th class="px-2">{{ $t('kpi.planDone') }}</th>
                    <th class="px-2">{{ $t('kpi.status') }}</th>
                    <th class="px-2">{{ $t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="kpi of getKpis" :key="kpi.id" class="h-11 border-bottom">
                    <td class="px-2">{{ kpi.id }}</td>
                    <td class="px-2">{{ getKpiType(kpi) }}</td>
                    <td class="px-2">{{ dateFormat(kpi.startAt) }}</td>
                    <td class="px-2">{{ dateFormat(kpi.endAt) }}</td>
                    <td v-if="kpi.isInSum" class="px-2">
                        {{ showCurrencyById(3, kpi.estimateSale) }}
                    </td>
                    <td v-else class="px-2">
                        {{ kpi.estimateSale }}
                    </td>
                    <td v-if="kpi.isInSum" class="px-2">
                        {{ showCurrencyById(3, kpi.realSale) }}
                    </td>
                    <td v-else class="px-2">
                        {{ kpi.realSale }}
                    </td>
                    <td class="px-2">{{ calcKpiPercent(kpi) }}%</td>
                    <td class="px-2">
                        <img v-if="!kpi.isFinished" src="/images/edit.png" @click="$i18nHelper.toUrl('employees/kpi/' + kpi.id)" alt="" class="h-6 cursor-pointer">
                        <img v-if="!kpi.isFinished" src="/images/palm-of-hand.png" @click="makeFinish(kpi.id)" alt="" class="h-6 ml-3 cursor-pointer">
                    </td>
                </tr>
            </tbody>
        </table>

        <table class="w-full d-md-none">
            <tbody v-for="kpi of getKpis" :key="kpi.id" style="border-bottom: 5px solid #989797">
                <tr class="h-11">
                    <th class="px-2 bg-lightGray">#</th>
                    <td class="px-2 bg-lightGray">{{ kpi.id }}</td>
                </tr>
                <tr class="h-11">
                    <th class="px-2">{{ $t('kpi.type') }}</th>
                    <td class="px-2">{{ getKpiType(kpi) }}</td>
                </tr>
                <tr class="h-11">
                    <th class="px-2">{{ $t('kpi.date.startDate') }}</th>
                    <td class="px-2">{{ dateFormat(kpi.startAt) }}</td>
                </tr>
                <tr class="h-11">
                    <th class="px-2">{{ $t('kpi.date.endDate') }}</th>
                    <td class="px-2">{{ dateFormat(kpi.endAt) }}</td>
                </tr>
                <tr class="h-11">
                    <th class="px-2">{{ $t('kpi.sum') }}</th>
                    <td v-if="kpi.isInSum" class="px-2">{{ showCurrencyById(3, kpi.estimateSale) }}</td>
                    <td v-else class="px-2">{{ kpi.estimateSale }}</td>
                </tr>
                <tr class="h-11">
                    <th class="px-2">{{ $t('kpi.planDone') }}</th>
                    <td v-if="kpi.isInSum" class="px-2">{{ showCurrencyById(3, kpi.realSale) }}</td>
                    <td v-else class="px-2">{{ kpi.realSale }}</td>
                </tr>
                <tr class="h-11">
                    <th class="px-2">{{ $t('kpi.status') }}</th>
                    <td class="px-2">{{ calcKpiPercent(kpi) }}%</td>
                </tr>
                <tr class="h-11">
                    <th class="px-2">{{ $t('actions') }}</th>
                    <td class="px-2">
                        <img v-if="!kpi.isFinished" src="/images/edit.png" @click="$i18nHelper.toUrl('employees/kpi/' + kpi.id)" alt="" class="h-6 cursor-pointer">
                        <img v-if="!kpi.isFinished" src="/images/palm-of-hand.png" @click="makeFinish(kpi.id)" alt="" class="h-6 ml-3 cursor-pointer">
                    </td>
                </tr>
            </tbody>
        </table>

        <PaginationRow
            class="py-5 pl-2"
            :search="search"
            base-url="k_p_is"
            method-name="searchKpis"
            :total-items="getKpisTotalCount"
        ></PaginationRow>
    </Row>
</template>

<script>
import Row from "@/components/html/Row.vue";
import ButtonTag from "@/components/html/ButtonTag.vue";
import accessMixin from "@/mixin/accessMixin";
import SearchCollapse from "@/components/SearchCollapse.vue";
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import PaginationRow from "@/components/PaginationRow.vue";
import Modal from "@/components/html/Modal.vue";
import InputBox from "@/components/InputBox.vue";

export default {
    name: "List",
    components: {InputBox, Modal, PaginationRow, SearchCollapse, ButtonTag, Row},
    mixins: [accessMixin, dateFormattingMixin, currencyFormatMixin],
    data() {
        return {
            isLoading: false,
            isDisabled: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees/kpi/list'},
                {name: 'kpi.title'},
            ],
            search: {
                type: 'all',
                isOnlyActive: false,
                startAt: null,
                endAt: null,
                page: 1
            },
            modalText: '',
            optionsMonth: [
                {text: this.$t('statistics.month.Jan')},
                {text: this.$t('statistics.month.Feb')},
                {text: this.$t('statistics.month.Mar')},
                {text: this.$t('statistics.month.Apr')},
                {text: this.$t('statistics.month.May')},
                {text: this.$t('statistics.month.Jun')},
                {text: this.$t('statistics.month.Jul')},
                {text: this.$t('statistics.month.Aug')},
                {text: this.$t('statistics.month.Sep')},
                {text: this.$t('statistics.month.Oct')},
                {text: this.$t('statistics.month.Nov')},
                {text: this.$t('statistics.month.Dec')},
            ],
        }
    },
    computed: {
        ...mapGetters(['getKpis', 'getKpisTotalCount', 'getKpi', 'getCurrencyByShortName'])
    },
    methods: {
        ...mapActions(['fetchKpis', 'fetchKpiStatus', 'searchKpis', 'makeFinishKpi', 'setBreadcrumbItems']),
        searchKpi(isOnlyActive) {
            this.search.isOnlyActive = !!isOnlyActive;

            this.searchKpis(this.search)
        },
        bgColorDefiner(kpi) {
            return kpi.isFinished ? 'height: 45px; background-color: #fc80a1' : kpi.isActive ? 'height: 45px' : 'height: 45px; background-color: #ffdf97'
        },
        makeFinish(id) {
            this.$root.showOverlay = true

            let data = {}
            data.id = id
            data.isFinished = true

            this
                .makeFinishKpi(data)
                .then(() => {
                    this.searchKpis(this.search)
                    this
                        .fetchKpiStatus()
                        .then(() => {
                            this.$root.showOverlay = false
                        })
                        .catch((reason) => {
                            this.$root.showOverlay = false

                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                })
                .catch((reason) => {
                    this.$root.showOverlay = false

                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        resetEmployeeSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this))
        },
        callAfterModal() {
            this.$bvModal.show('after')
        },
        callBeforeModal() {
            this.$bvModal.show('before')
        },
        getKpiType(kpi) {
            switch (kpi.type) {
                case 0:
                    return this.$t('kpi.period.daily')
                case 1:
                    return this.$t('kpi.period.weekly')
                case 2:
                    return this.$t('kpi.period.monthly')
            }
        },
        calcKpiPercent(kpi) {
            return Math.round(kpi.realSale * 100 / kpi.estimateSale)
        },
        getTodayDate() {
            let today = new Date()

            return today.getDate() + '-' + this.optionsMonth[today.getMonth()].text
        },
        calcDiffPercent(kpi) {
            if (kpi.estimateSaleAmount === '0' || kpi.realSaleAmount) {
                return 0
            }

            if (kpi.estimateSaleAmount > kpi.realSaleAmount) {
                return Math.round((kpi.estimateSaleAmount - kpi.realSaleAmount) * 100 / kpi.estimateSaleAmount)
            }

            return Math.round((kpi.realSaleAmount - kpi.estimateSaleAmount) * 100 / kpi.estimateSaleAmount)
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true

        this
            .fetchKpiStatus()
            .then(() => {
                this.$root.showOverlay = false
            })
            .catch((reason) => {
                this.$root.showOverlay = false

                this.modalText = reason
                this.$bvModal.show('modal_show')
            })
    }
}
</script>

<style scoped>
.card {
    background-color: #F8F8F8;
}

.icon-link-red {
    color: red;
    font-size: 13px;
    position: relative;
    bottom: 15px;
}

.icon-link-green {
    color: #04f304;
    font-size: 13px;
    position: relative;
    bottom: 15px;
}

.percent {
    position: relative;
    bottom: 35px;
    left: 100px;
    font-size: 13px;
}
</style>
